import { render, staticRenderFns } from "./post_recommend_record.vue?vue&type=template&id=0f8478dc&scoped=true"
import script from "./post_recommend_record.vue?vue&type=script&lang=ts"
export * from "./post_recommend_record.vue?vue&type=script&lang=ts"
import style0 from "./post_recommend_record.vue?vue&type=style&index=0&id=0f8478dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8478dc",
  null
  
)

export default component.exports